// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   AI COMMAND CENTER STYLES - LIGHT THEME
   =========================================== */

:root {
    /* Primary Colors */
    --primary-color: #2563eb;
    --primary-dark: #1e40af;
    --primary-light: #3b82f6;
    --primary-lighter: #60a5fa;

    /* Background Colors */
    --bg-primary: #f8fafc;
    --bg-secondary: #f0f4f8;
    --bg-card: #ffffff;
    --bg-input: #f1f5f9;
    --bg-hover: #eff6ff;

    /* Text Colors */
    --text-primary: #1e293b;
    --text-secondary: #475569;
    --text-muted: #64748b;
    --text-light: #94a3b8;

    /* Border Colors */
    --border-color: #e2e8f0;
    --border-light: #cbd5e1;
    --border-focus: #2563eb;

    /* Status Colors */
    --success: #10b981;
    --warning: #f59e0b;
    --error: #ef4444;
    --info: #06b6d4;

    /* Gradients */
    --gradient-blue: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
    --gradient-light: linear-gradient(135deg, #f8fafc 0%, #f0f4f8 100%);

    /* Shadows */
    --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);
    --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.1);
    --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.1);
    --shadow-xl: 0 20px 25px rgba(0, 0, 0, 0.1);

    /* Transitions */
    --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* ==========================================
   GLOBAL STYLES
   =========================================== */

/* ==========================================
   MAIN CONTAINER
   =========================================== */

.ai-command-center-container {
    /* min-height: 100vh; */
    background: linear-gradient(135deg, #f8fafc 0%, #f0f4f8 50%, #e0e7ff 100%);
    padding: 15px;
}

/* ==========================================
   HEADER SECTION
   =========================================== */

.command-header {
    margin-bottom: 10px;
    padding: 20px;
    background: linear-gradient(135deg, #ffffff 0%, #f9fafb 100%);
    border: 1px solid var(--border-color);
    border-radius: 14px;
    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.08);
}

.phase-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 14px;
    background: linear-gradient(135deg, rgba(37, 99, 235, 0.1) 0%, rgba(59, 130, 246, 0.1) 100%);
    border: 1px solid rgba(37, 99, 235, 0.2);
    border-radius: 20px;
    font-size: 11px;
    font-weight: 700;
    color: var(--primary-dark);
    text-transform: uppercase;
    letter-spacing: 0.8px;
    margin-bottom: 16px;
}

.phase-badge svg {
    width: 14px;
    height: 14px;
    color: var(--primary-color);
}

.header-title {
    font-size: 36px;
    font-weight: 700;
    color: var(--text-primary);
    margin-bottom: 12px;
    letter-spacing: -0.5px;
}

.header-description {
    font-size: 15px;
    color: var(--text-secondary);
    line-height: 1.6;
    margin-bottom: 0px;
    /* max-width: 900px; */
}

/* ==========================================
   COMMAND CONTENT LAYOUT
   =========================================== */

.command-content {
    /* display: grid; */
    grid-template-columns: 1fr 1fr;
    /* gap: 12px; */
    max-width: 1600px;
    margin: 0 auto;
}

@media (max-width: 1200px) {
    .command-content {
        grid-template-columns: 1fr;
    }
}

/* ==========================================
   LEFT SECTION
   =========================================== */

.Ai-left-section {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

/* ==========================================
   CARD STYLES
   =========================================== */

.quick-templates-card,
.ai-command-card,
.advanced-params-card,
.output-card {
    background: var(--bg-card);
    border: 1px solid var(--border-color);
    border-radius: 12px;
    overflow: hidden;
    box-shadow: var(--shadow-md);
    transition: var(--transition);
}

.quick-templates-card:hover,
.ai-command-card:hover,
.advanced-params-card:hover,
.output-card:hover {
    border-color: var(--primary-light);
    box-shadow: 0 12px 24px rgba(37, 99, 235, 0.12);
}

.card-header-Ai {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px;
    background: linear-gradient(135deg, #dbedff 0%, #f3f4f6 100%);
    border-bottom: 1px solid var(--border-color);
    position: relative;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
}

.header-icon {
    width: 18px;
    height: 18px;
    color: var(--primary-color);
    flex-shrink: 0;
}

.card-header-Ai h2 {
    margin: 0;
    font-size: 15px;
    font-weight: 600;
    color: var(--text-primary);
    flex: 1 1;
}

.header-left {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1 1;
}

.knowledge-base-btn {
    padding: 6px 12px;
    background: linear-gradient(135deg, #e0e7ff 0%, #ddd6fe 100%);
    border: 1px solid rgba(37, 99, 235, 0.2);
    border-radius: 6px;
    color: var(--primary-dark);
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
    transition: var(--transition);
}

.knowledge-base-btn:hover {
    background: linear-gradient(135deg, #c7d2fe 0%, #c4b5fd 100%);
    border-color: var(--primary-color);
}

/* ==========================================
   TEMPLATES GRID
   =========================================== */
.templates-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    /* padding: 16px 20px; */
}

/* Modern Chip */
.template-chip {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 4px 12px;
    border-radius: 999px;
    font-size: 10px;
    font-weight: 500;
    cursor: pointer;
    border: 1px solid transparent;
    background: rgba(255, 255, 255, 0.05);
    color: #100f0f;
    transition: all 0.25s ease;
    backdrop-filter: blur(8px);
}

/* Icon */
.template-icon {
    font-size: 14px;
    display: flex;
    align-items: center;
}

/* Hover Effect */
.template-chip:hover {
    background: var(--chip-color);
    color: #fff;
    transform: translateY(-1px);
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);
}

/* Active (Selected) */
.template-chip.active {
    background: var(--chip-color);
    color: #fff;
    box-shadow: 0 0 10px var(--chip-color);
}

/* Optional subtle border glow */
.template-chip {
    border: 1px solid rgba(255, 255, 255, 0.08);
}

.ai-container {
    /* height: 100vh; */
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

/* ==========================================
   AI COMMAND CARD
   =========================================== */

.command-input-section {
    padding: 16px;
}

.input-wrapper {
    position: relative;
    display: flex;
    gap: 12px;
    margin-bottom: 16px;
}

.command-input {
    flex: 1 1;
    padding: 14px;
    border: 1px solid var(--border-color);
    border-radius: 8px;
    background: var(--bg-input);
    color: var(--text-primary);
    font-size: 13px;
    font-family: 'Segoe UI', Roboto, sans-serif;
    resize: vertical;
    min-height: 100px;
    transition: var(--transition);
}

.command-input:focus {
    outline: none;
    border-color: var(--primary-color);
    background: white;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.command-input::placeholder {
    color: var(--text-light);
}

.send-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    border: none;
    background: linear-gradient(135deg, #abaeff, #4f46e5);
    color: white;
    cursor: pointer;
    transition: all 0.25s ease;
    box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
}

/* Hover */
.send-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 18px rgba(99, 102, 241, 0.4);
}

/* Click */
.send-btn:active {
    transform: scale(0.95);
}

/* Disabled */
.send-btn:disabled {
    background: #e5e7eb;
    color: #9ca3af;
    cursor: not-allowed;
    box-shadow: none;
}

.input-hint {
    font-size: 12px;
    color: var(--text-muted);
    margin-bottom: 3px;
    font-weight: 600;
}

/* ==========================================
   FORM FIELDS
   =========================================== */

.form-outer-AI {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
    /* padding: 0 16px 16px; */
}

.form-outer-AI:has(.form-field-AI:nth-child(2):last-child) {
    grid-template-columns: repeat(2, 1fr);
}

@media (max-width: 768px) {
    .form-outer-AI {
        grid-template-columns: 1fr;
    }
}

.form-field-AI {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.form-field-AI label {
    font-size: 11px;
    font-weight: 700;
    color: var(--text-secondary);
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.form-input-AI {
    padding: 10px 12px;
    border: 1px solid var(--border-color);
    border-radius: 6px;
    background: var(--bg-input);
    color: var(--text-primary);
    font-size: 13px;
    transition: var(--transition);
}

.form-input-AI:focus {
    outline: none;
    border-color: var(--primary-color);
    background: white;
    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
}

/* ==========================================
   EXECUTE BUTTON
   =========================================== */

.execute-btn {
    padding: 9px 20px;
    /* margin: 0 16px 20px; */
    background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);
    border: none;
    border-radius: 8px;
    color: white;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: var(--transition);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: calc(100% - 48px);
    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
}

.execute-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(37, 99, 235, 0.4);
}

.execute-btn:active {
    transform: translateY(0);
}

.execute-btn svg {
    width: 18px;
    height: 18px;
}

.execute-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
}

.trash-icon {
    /* position: absolute; */
    /* right: 20px;
    bottom: 20px; */
    padding: 8px;
    background: var(--bg-input);
    border: 1px solid var(--border-color);
    border-radius: 6px;
    color: var(--text-muted);
    cursor: pointer;
    transition: var(--transition);
    display: flex;
    align-items: center;
    justify-content: center;
}

.trash-icon:hover {
    background: #fee2e2;
    border-color: var(--error);
    color: var(--error);
}

/* ==========================================
   ADVANCED PARAMETERS
   =========================================== */

.advanced-params-card {
    position: relative;
}

.params-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    padding: 16px;
}

@media (max-width: 768px) {
    .params-grid {
        grid-template-columns: 1fr;
    }
}

.param-field {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.param-field label {
    font-size: 11px;
    font-weight: 700;
    color: var(--text-secondary);
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.param-input {
    padding: 10px 12px;
    border: 1px solid var(--border-color);
    border-radius: 6px;
    /* background: var(--bg-input); */
    color: var(--text-primary);
    font-size: 13px;
    transition: var(--transition);
}

.param-input:focus {
    outline: none;
    border-color: var(--primary-color);
    background: white;
    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
}

/* ==========================================
   TOGGLE SECTION
   =========================================== */

.toggle-section {
    padding: 16px 16px 16px;
    border-top: 1px solid var(--border-color);
}

.toggle-label {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
}

.toggle-input {
    width: 18px;
    height: 18px;
    cursor: pointer;
    accent-color: var(--primary-color);
}

.toggle-text {
    font-size: 13px;
    color: var(--text-secondary);
    font-weight: 500;
}

/* ==========================================
   OUTPUT SECTION
   =========================================== */

.Ai-right-section {
    display: flex;
    flex-direction: column;
    /* width: 100%; */
    overflow: hidden;
}

.output-card {
    display: flex;
    flex-direction: column;
    /* height: 100%; */
}

.output-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px;
    background: linear-gradient(135deg, #dbedff 0%, #f3f4f6 100%);
    border-bottom: 1px solid var(--border-color);
}

.output-title {
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1 1;
}

.output-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--primary-color);
    animation: pulse 2s infinite;
}

.output-title h2 {
    margin: 0;
    font-size: 15px;
    font-weight: 600;
    color: var(--text-primary);
}

.output-actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

.output-action-btn {
    padding: 8px;
    background: transparent;
    border: 1px solid var(--border-color);
    border-radius: 6px;
    color: var(--text-muted);
    cursor: pointer;
    transition: var(--transition);
    display: flex;
    align-items: center;
    justify-content: center;
}

.output-action-btn:hover {
    background: var(--bg-hover);
    border-color: var(--primary-color);
    color: var(--primary-color);
}

.output-content {
    /* flex: 1; */
    padding: 15px;
    background: #f8f9fa;
    font-family: 'Courier New', monospace;
    font-size: 12px;
    color: var(--primary-color);
    line-height: 1.5;
    white-space: pre-wrap;
    word-break: break-word;
    overflow-wrap: break-word;
    border-top: 1px solid var(--border-color);
    overflow: auto;
    /* max-height: 100%; */
    height: calc(100vh - 360px);
}
.question-output{
  height: calc(100vh - 210px);  
}
.md-h1 {
    font-size: 22px;
    font-weight: 700;
    margin-bottom: 12px;
}

.md-h2 {
    font-size: 18px;
    font-weight: 600;
    margin: 10px 0;
}

.md-h3 {
    font-size: 16px;
    font-weight: 600;
    margin: 8px 0;
}

/* Paragraph */
.md-p {
    margin-bottom: 8px;
}

/* List */
.md-li {
    margin-left: 16px;
    margin-bottom: 4px;
}

.output-content code {
    font-family: 'Courier New', monospace;
    /* color: var(--primary-color); */
    color: #000000;
}

.output-content::-webkit-scrollbar {
    width: 8px;
}

.output-content::-webkit-scrollbar-track {
    background: transparent;
}

.output-content::-webkit-scrollbar-thumb {
    background: rgba(37, 99, 235, 0.2);
    border-radius: 4px;
}

.output-content::-webkit-scrollbar-thumb:hover {
    background: rgba(37, 99, 235, 0.4);
}

/* ==========================================
   ANIMATIONS
   =========================================== */

@keyframes pulse {

    0%,
    100% {
        opacity: 1;
    }

    50% {
        opacity: 0.5;
    }
}

@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.ai-command-center-container {
    animation: slideIn 0.6s ease-out;
}

/* ==========================================
   RESPONSIVE DESIGN
   =========================================== */

@media (max-width: 1200px) {
    .command-header {
        padding: 24px;
    }

    .header-title {
        font-size: 28px;
    }

    .templates-grid {
        grid-template-columns: repeat(4, 1fr);
    }
}

@media (max-width: 768px) {
    .ai-command-center-container {
        padding: 24px 16px;
    }

    .command-header {
        padding: 20px;
        margin-bottom: 24px;
    }

    .header-title {
        font-size: 24px;
    }

    .header-description {
        font-size: 14px;
    }

    /* .command-content {
        gap: 20px;
    } */

    .templates-grid {
        grid-template-columns: repeat(3, 1fr);
        gap: 10px;
        /* padding: 16px; */
    }

    .form-outer-AI {
        grid-template-columns: 1fr;
        gap: 12px;
        /* padding: 0 16px 16px; */
    }

    .execute-btn {
        margin: 0 16px 16px;
        width: calc(100% - 32px);
    }

    .params-grid {
        gap: 12px;
        padding: 16px;
    }

    .command-input-section {
        padding: 16px;
    }

    .output-content {
        padding: 16px;
    }
}

@media (max-width: 480px) {
    .command-header {
        padding: 16px;
    }

    .header-title {
        font-size: 20px;
        margin-bottom: 8px;
    }

    .templates-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 8px;
        /* padding: 12px; */
    }

    .template-btn {
        padding: 10px;
        gap: 6px;
    }

    .template-icon {
        font-size: 18px;
    }

    .template-name {
        font-size: 11px;
    }

    .command-input {
        min-height: 80px;
    }

    /* .form-outer-AI {
        padding: 0 12px 12px;
    } */

    .form-input-AI {
        font-size: 12px;
    }

    .param-input {
        font-size: 12px;
    }

    .execute-btn {
        margin: 0 12px 12px;
        width: calc(100% - 24px);
        font-size: 13px;
        padding: 12px 16px;
    }
}

/* ==========================================
   UTILITY CLASSES
   =========================================== */

.text-primary {
    color: var(--text-primary);
}

.text-secondary {
    color: var(--text-secondary);
}

.text-muted {
    color: var(--text-muted);
}

.bg-light {
    background: var(--bg-primary);
}

.border-light {
    border-color: var(--border-color);
}

.shadow-md {
    box-shadow: var(--shadow-md);
}

.transition {
    transition: var(--transition);
}`, "",{"version":3,"sources":["webpack://./src/Screen/AIPanel/AI Command/AICommand.css"],"names":[],"mappings":"AAAA;;gDAEgD;;AAEhD;IACI,mBAAmB;IACnB,wBAAwB;IACxB,uBAAuB;IACvB,wBAAwB;IACxB,0BAA0B;;IAE1B,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;;IAEnB,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;;IAErB,kBAAkB;IAClB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;;IAEvB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;;IAEf,cAAc;IACd,kEAAkE;IAClE,mEAAmE;;IAEnE,YAAY;IACZ,0CAA0C;IAC1C,yCAAyC;IACzC,2CAA2C;IAC3C,2CAA2C;;IAE3C,gBAAgB;IAChB,mDAAmD;AACvD;;AAEA;;gDAEgD;;AAEhD;;gDAEgD;;AAEhD;IACI,uBAAuB;IACvB,0EAA0E;IAC1E,aAAa;AACjB;;AAEA;;gDAEgD;;AAEhD;IACI,mBAAmB;IACnB,aAAa;IACb,6DAA6D;IAC7D,qCAAqC;IACrC,mBAAmB;IACnB,8CAA8C;AAClD;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,4FAA4F;IAC5F,wCAAwC;IACxC,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;;gDAEgD;;AAEhD;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;;gDAEgD;;AAEhD;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;;gDAEgD;;AAEhD;;;;IAII,0BAA0B;IAC1B,qCAAqC;IACrC,mBAAmB;IACnB,gBAAgB;IAChB,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;;;;IAII,kCAAkC;IAClC,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,6DAA6D;IAC7D,4CAA4C;IAC5C,kBAAkB;IAClB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,SAAO;AACX;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,SAAO;AACX;;AAEA;IACI,iBAAiB;IACjB,6DAA6D;IAC7D,wCAAwC;IACxC,kBAAkB;IAClB,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,6DAA6D;IAC7D,kCAAkC;AACtC;;AAEA;;gDAEgD;AAChD;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,wBAAwB;AAC5B;;AAEA,gBAAgB;AAChB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,qCAAqC;IACrC,cAAc;IACd,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA,SAAS;AACT;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA,iBAAiB;AACjB;IACI,6BAA6B;IAC7B,WAAW;IACX,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA,sBAAsB;AACtB;IACI,6BAA6B;IAC7B,WAAW;IACX,sCAAsC;AAC1C;;AAEA,gCAAgC;AAChC;IACI,2CAA2C;AAC/C;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;;gDAEgD;;AAEhD;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,qCAAqC;IACrC,kBAAkB;IAClB,2BAA2B;IAC3B,0BAA0B;IAC1B,eAAe;IACf,2CAA2C;IAC3C,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,iBAAiB;IACjB,4CAA4C;AAChD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,qDAAqD;IACrD,YAAY;IACZ,eAAe;IACf,0BAA0B;IAC1B,8CAA8C;AAClD;;AAEA,UAAU;AACV;IACI,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA,UAAU;AACV;IACI,sBAAsB;AAC1B;;AAEA,aAAa;AACb;IACI,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;gDAEgD;;AAEhD;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,qCAAqC;IACrC,kBAAkB;IAClB,2BAA2B;IAC3B,0BAA0B;IAC1B,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,iBAAiB;IACjB,4CAA4C;AAChD;;AAEA;;gDAEgD;;AAEhD;IACI,iBAAiB;IACjB,yBAAyB;IACzB,6DAA6D;IAC7D,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,wBAAwB;IACxB,6CAA6C;AACjD;;AAEA;IACI,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB;mBACe;IACf,YAAY;IACZ,2BAA2B;IAC3B,qCAAqC;IACrC,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;IACf,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;;gDAEgD;;AAEhD;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,aAAa;AACjB;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,qCAAqC;IACrC,kBAAkB;IAClB,iCAAiC;IACjC,0BAA0B;IAC1B,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,iBAAiB;IACjB,4CAA4C;AAChD;;AAEA;;gDAEgD;;AAEhD;IACI,uBAAuB;IACvB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;;gDAEgD;;AAEhD;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,aAAa;IACb,6DAA6D;IAC7D,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,SAAO;AACX;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,gCAAgC;IAChC,4BAA4B;AAChC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,qCAAqC;IACrC,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;IACf,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;IAC3B,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,qCAAqC;IACrC,eAAe;IACf,2BAA2B;IAC3B,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;IACtB,yBAAyB;IACzB,yCAAyC;IACzC,cAAc;IACd,sBAAsB;IACtB,2BAA2B;AAC/B;AACA;EACE,2BAA2B;AAC7B;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;AACjB;;AAEA,cAAc;AACd;IACI,kBAAkB;AACtB;;AAEA,SAAS;AACT;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,iCAAiC;IACjC,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;;gDAEgD;;AAEhD;;IAEI;;QAEI,UAAU;IACd;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;gDAEgD;;AAEhD;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;;OAEG;;IAEH;QACI,qCAAqC;QACrC,SAAS;QACT,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;QAC1B,SAAS;QACT,0BAA0B;IAC9B;;IAEA;QACI,mBAAmB;QACnB,wBAAwB;IAC5B;;IAEA;QACI,SAAS;QACT,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,qCAAqC;QACrC,QAAQ;QACR,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,QAAQ;IACZ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;;OAEG;;IAEH;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,wBAAwB;QACxB,eAAe;QACf,kBAAkB;IACtB;AACJ;;AAEA;;gDAEgD;;AAEhD;IACI,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;AACjC","sourcesContent":["/* ==========================================\n   AI COMMAND CENTER STYLES - LIGHT THEME\n   =========================================== */\n\n:root {\n    /* Primary Colors */\n    --primary-color: #2563eb;\n    --primary-dark: #1e40af;\n    --primary-light: #3b82f6;\n    --primary-lighter: #60a5fa;\n\n    /* Background Colors */\n    --bg-primary: #f8fafc;\n    --bg-secondary: #f0f4f8;\n    --bg-card: #ffffff;\n    --bg-input: #f1f5f9;\n    --bg-hover: #eff6ff;\n\n    /* Text Colors */\n    --text-primary: #1e293b;\n    --text-secondary: #475569;\n    --text-muted: #64748b;\n    --text-light: #94a3b8;\n\n    /* Border Colors */\n    --border-color: #e2e8f0;\n    --border-light: #cbd5e1;\n    --border-focus: #2563eb;\n\n    /* Status Colors */\n    --success: #10b981;\n    --warning: #f59e0b;\n    --error: #ef4444;\n    --info: #06b6d4;\n\n    /* Gradients */\n    --gradient-blue: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);\n    --gradient-light: linear-gradient(135deg, #f8fafc 0%, #f0f4f8 100%);\n\n    /* Shadows */\n    --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);\n    --shadow-md: 0 4px 6px rgba(0, 0, 0, 0.1);\n    --shadow-lg: 0 10px 15px rgba(0, 0, 0, 0.1);\n    --shadow-xl: 0 20px 25px rgba(0, 0, 0, 0.1);\n\n    /* Transitions */\n    --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* ==========================================\n   GLOBAL STYLES\n   =========================================== */\n\n/* ==========================================\n   MAIN CONTAINER\n   =========================================== */\n\n.ai-command-center-container {\n    /* min-height: 100vh; */\n    background: linear-gradient(135deg, #f8fafc 0%, #f0f4f8 50%, #e0e7ff 100%);\n    padding: 15px;\n}\n\n/* ==========================================\n   HEADER SECTION\n   =========================================== */\n\n.command-header {\n    margin-bottom: 10px;\n    padding: 20px;\n    background: linear-gradient(135deg, #ffffff 0%, #f9fafb 100%);\n    border: 1px solid var(--border-color);\n    border-radius: 14px;\n    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.08);\n}\n\n.phase-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 14px;\n    background: linear-gradient(135deg, rgba(37, 99, 235, 0.1) 0%, rgba(59, 130, 246, 0.1) 100%);\n    border: 1px solid rgba(37, 99, 235, 0.2);\n    border-radius: 20px;\n    font-size: 11px;\n    font-weight: 700;\n    color: var(--primary-dark);\n    text-transform: uppercase;\n    letter-spacing: 0.8px;\n    margin-bottom: 16px;\n}\n\n.phase-badge svg {\n    width: 14px;\n    height: 14px;\n    color: var(--primary-color);\n}\n\n.header-title {\n    font-size: 36px;\n    font-weight: 700;\n    color: var(--text-primary);\n    margin-bottom: 12px;\n    letter-spacing: -0.5px;\n}\n\n.header-description {\n    font-size: 15px;\n    color: var(--text-secondary);\n    line-height: 1.6;\n    margin-bottom: 0px;\n    /* max-width: 900px; */\n}\n\n/* ==========================================\n   COMMAND CONTENT LAYOUT\n   =========================================== */\n\n.command-content {\n    /* display: grid; */\n    grid-template-columns: 1fr 1fr;\n    /* gap: 12px; */\n    max-width: 1600px;\n    margin: 0 auto;\n}\n\n@media (max-width: 1200px) {\n    .command-content {\n        grid-template-columns: 1fr;\n    }\n}\n\n/* ==========================================\n   LEFT SECTION\n   =========================================== */\n\n.Ai-left-section {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n/* ==========================================\n   CARD STYLES\n   =========================================== */\n\n.quick-templates-card,\n.ai-command-card,\n.advanced-params-card,\n.output-card {\n    background: var(--bg-card);\n    border: 1px solid var(--border-color);\n    border-radius: 12px;\n    overflow: hidden;\n    box-shadow: var(--shadow-md);\n    transition: var(--transition);\n}\n\n.quick-templates-card:hover,\n.ai-command-card:hover,\n.advanced-params-card:hover,\n.output-card:hover {\n    border-color: var(--primary-light);\n    box-shadow: 0 12px 24px rgba(37, 99, 235, 0.12);\n}\n\n.card-header-Ai {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 12px;\n    background: linear-gradient(135deg, #dbedff 0%, #f3f4f6 100%);\n    border-bottom: 1px solid var(--border-color);\n    position: relative;\n    border-top-left-radius: 5px;\n    border-top-right-radius: 5px;\n}\n\n.header-icon {\n    width: 18px;\n    height: 18px;\n    color: var(--primary-color);\n    flex-shrink: 0;\n}\n\n.card-header-Ai h2 {\n    margin: 0;\n    font-size: 15px;\n    font-weight: 600;\n    color: var(--text-primary);\n    flex: 1;\n}\n\n.header-left {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex: 1;\n}\n\n.knowledge-base-btn {\n    padding: 6px 12px;\n    background: linear-gradient(135deg, #e0e7ff 0%, #ddd6fe 100%);\n    border: 1px solid rgba(37, 99, 235, 0.2);\n    border-radius: 6px;\n    color: var(--primary-dark);\n    font-size: 11px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: var(--transition);\n}\n\n.knowledge-base-btn:hover {\n    background: linear-gradient(135deg, #c7d2fe 0%, #c4b5fd 100%);\n    border-color: var(--primary-color);\n}\n\n/* ==========================================\n   TEMPLATES GRID\n   =========================================== */\n.templates-grid {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n    /* padding: 16px 20px; */\n}\n\n/* Modern Chip */\n.template-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 4px 12px;\n    border-radius: 999px;\n    font-size: 10px;\n    font-weight: 500;\n    cursor: pointer;\n    border: 1px solid transparent;\n    background: rgba(255, 255, 255, 0.05);\n    color: #100f0f;\n    transition: all 0.25s ease;\n    backdrop-filter: blur(8px);\n}\n\n/* Icon */\n.template-icon {\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n}\n\n/* Hover Effect */\n.template-chip:hover {\n    background: var(--chip-color);\n    color: #fff;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);\n}\n\n/* Active (Selected) */\n.template-chip.active {\n    background: var(--chip-color);\n    color: #fff;\n    box-shadow: 0 0 10px var(--chip-color);\n}\n\n/* Optional subtle border glow */\n.template-chip {\n    border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.ai-container {\n    /* height: 100vh; */\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n/* ==========================================\n   AI COMMAND CARD\n   =========================================== */\n\n.command-input-section {\n    padding: 16px;\n}\n\n.input-wrapper {\n    position: relative;\n    display: flex;\n    gap: 12px;\n    margin-bottom: 16px;\n}\n\n.command-input {\n    flex: 1;\n    padding: 14px;\n    border: 1px solid var(--border-color);\n    border-radius: 8px;\n    background: var(--bg-input);\n    color: var(--text-primary);\n    font-size: 13px;\n    font-family: 'Segoe UI', Roboto, sans-serif;\n    resize: vertical;\n    min-height: 100px;\n    transition: var(--transition);\n}\n\n.command-input:focus {\n    outline: none;\n    border-color: var(--primary-color);\n    background: white;\n    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n.command-input::placeholder {\n    color: var(--text-light);\n}\n\n.send-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 44px;\n    height: 44px;\n    border-radius: 50%;\n    border: none;\n    background: linear-gradient(135deg, #abaeff, #4f46e5);\n    color: white;\n    cursor: pointer;\n    transition: all 0.25s ease;\n    box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);\n}\n\n/* Hover */\n.send-btn:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 18px rgba(99, 102, 241, 0.4);\n}\n\n/* Click */\n.send-btn:active {\n    transform: scale(0.95);\n}\n\n/* Disabled */\n.send-btn:disabled {\n    background: #e5e7eb;\n    color: #9ca3af;\n    cursor: not-allowed;\n    box-shadow: none;\n}\n\n.input-hint {\n    font-size: 12px;\n    color: var(--text-muted);\n    margin-bottom: 3px;\n    font-weight: 600;\n}\n\n/* ==========================================\n   FORM FIELDS\n   =========================================== */\n\n.form-outer-AI {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 12px;\n    /* padding: 0 16px 16px; */\n}\n\n.form-outer-AI:has(.form-field-AI:nth-child(2):last-child) {\n    grid-template-columns: repeat(2, 1fr);\n}\n\n@media (max-width: 768px) {\n    .form-outer-AI {\n        grid-template-columns: 1fr;\n    }\n}\n\n.form-field-AI {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.form-field-AI label {\n    font-size: 11px;\n    font-weight: 700;\n    color: var(--text-secondary);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.form-input-AI {\n    padding: 10px 12px;\n    border: 1px solid var(--border-color);\n    border-radius: 6px;\n    background: var(--bg-input);\n    color: var(--text-primary);\n    font-size: 13px;\n    transition: var(--transition);\n}\n\n.form-input-AI:focus {\n    outline: none;\n    border-color: var(--primary-color);\n    background: white;\n    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);\n}\n\n/* ==========================================\n   EXECUTE BUTTON\n   =========================================== */\n\n.execute-btn {\n    padding: 9px 20px;\n    /* margin: 0 16px 20px; */\n    background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);\n    border: none;\n    border-radius: 8px;\n    color: white;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: var(--transition);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    width: calc(100% - 48px);\n    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);\n}\n\n.execute-btn:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(37, 99, 235, 0.4);\n}\n\n.execute-btn:active {\n    transform: translateY(0);\n}\n\n.execute-btn svg {\n    width: 18px;\n    height: 18px;\n}\n\n.execute-btn:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    transform: none;\n    box-shadow: none;\n}\n\n.trash-icon {\n    /* position: absolute; */\n    /* right: 20px;\n    bottom: 20px; */\n    padding: 8px;\n    background: var(--bg-input);\n    border: 1px solid var(--border-color);\n    border-radius: 6px;\n    color: var(--text-muted);\n    cursor: pointer;\n    transition: var(--transition);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.trash-icon:hover {\n    background: #fee2e2;\n    border-color: var(--error);\n    color: var(--error);\n}\n\n/* ==========================================\n   ADVANCED PARAMETERS\n   =========================================== */\n\n.advanced-params-card {\n    position: relative;\n}\n\n.params-grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 16px;\n    padding: 16px;\n}\n\n@media (max-width: 768px) {\n    .params-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n.param-field {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.param-field label {\n    font-size: 11px;\n    font-weight: 700;\n    color: var(--text-secondary);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.param-input {\n    padding: 10px 12px;\n    border: 1px solid var(--border-color);\n    border-radius: 6px;\n    /* background: var(--bg-input); */\n    color: var(--text-primary);\n    font-size: 13px;\n    transition: var(--transition);\n}\n\n.param-input:focus {\n    outline: none;\n    border-color: var(--primary-color);\n    background: white;\n    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);\n}\n\n/* ==========================================\n   TOGGLE SECTION\n   =========================================== */\n\n.toggle-section {\n    padding: 16px 16px 16px;\n    border-top: 1px solid var(--border-color);\n}\n\n.toggle-label {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    cursor: pointer;\n}\n\n.toggle-input {\n    width: 18px;\n    height: 18px;\n    cursor: pointer;\n    accent-color: var(--primary-color);\n}\n\n.toggle-text {\n    font-size: 13px;\n    color: var(--text-secondary);\n    font-weight: 500;\n}\n\n/* ==========================================\n   OUTPUT SECTION\n   =========================================== */\n\n.Ai-right-section {\n    display: flex;\n    flex-direction: column;\n    /* width: 100%; */\n    overflow: hidden;\n}\n\n.output-card {\n    display: flex;\n    flex-direction: column;\n    /* height: 100%; */\n}\n\n.output-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    padding: 12px;\n    background: linear-gradient(135deg, #dbedff 0%, #f3f4f6 100%);\n    border-bottom: 1px solid var(--border-color);\n}\n\n.output-title {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex: 1;\n}\n\n.output-dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: var(--primary-color);\n    animation: pulse 2s infinite;\n}\n\n.output-title h2 {\n    margin: 0;\n    font-size: 15px;\n    font-weight: 600;\n    color: var(--text-primary);\n}\n\n.output-actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.output-action-btn {\n    padding: 8px;\n    background: transparent;\n    border: 1px solid var(--border-color);\n    border-radius: 6px;\n    color: var(--text-muted);\n    cursor: pointer;\n    transition: var(--transition);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.output-action-btn:hover {\n    background: var(--bg-hover);\n    border-color: var(--primary-color);\n    color: var(--primary-color);\n}\n\n.output-content {\n    /* flex: 1; */\n    padding: 15px;\n    background: #f8f9fa;\n    font-family: 'Courier New', monospace;\n    font-size: 12px;\n    color: var(--primary-color);\n    line-height: 1.5;\n    white-space: pre-wrap;\n    word-break: break-word;\n    overflow-wrap: break-word;\n    border-top: 1px solid var(--border-color);\n    overflow: auto;\n    /* max-height: 100%; */\n    height: calc(100vh - 360px);\n}\n.question-output{\n  height: calc(100vh - 210px);  \n}\n.md-h1 {\n    font-size: 22px;\n    font-weight: 700;\n    margin-bottom: 12px;\n}\n\n.md-h2 {\n    font-size: 18px;\n    font-weight: 600;\n    margin: 10px 0;\n}\n\n.md-h3 {\n    font-size: 16px;\n    font-weight: 600;\n    margin: 8px 0;\n}\n\n/* Paragraph */\n.md-p {\n    margin-bottom: 8px;\n}\n\n/* List */\n.md-li {\n    margin-left: 16px;\n    margin-bottom: 4px;\n}\n\n.output-content code {\n    font-family: 'Courier New', monospace;\n    /* color: var(--primary-color); */\n    color: #000000;\n}\n\n.output-content::-webkit-scrollbar {\n    width: 8px;\n}\n\n.output-content::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.output-content::-webkit-scrollbar-thumb {\n    background: rgba(37, 99, 235, 0.2);\n    border-radius: 4px;\n}\n\n.output-content::-webkit-scrollbar-thumb:hover {\n    background: rgba(37, 99, 235, 0.4);\n}\n\n/* ==========================================\n   ANIMATIONS\n   =========================================== */\n\n@keyframes pulse {\n\n    0%,\n    100% {\n        opacity: 1;\n    }\n\n    50% {\n        opacity: 0.5;\n    }\n}\n\n@keyframes slideIn {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.ai-command-center-container {\n    animation: slideIn 0.6s ease-out;\n}\n\n/* ==========================================\n   RESPONSIVE DESIGN\n   =========================================== */\n\n@media (max-width: 1200px) {\n    .command-header {\n        padding: 24px;\n    }\n\n    .header-title {\n        font-size: 28px;\n    }\n\n    .templates-grid {\n        grid-template-columns: repeat(4, 1fr);\n    }\n}\n\n@media (max-width: 768px) {\n    .ai-command-center-container {\n        padding: 24px 16px;\n    }\n\n    .command-header {\n        padding: 20px;\n        margin-bottom: 24px;\n    }\n\n    .header-title {\n        font-size: 24px;\n    }\n\n    .header-description {\n        font-size: 14px;\n    }\n\n    /* .command-content {\n        gap: 20px;\n    } */\n\n    .templates-grid {\n        grid-template-columns: repeat(3, 1fr);\n        gap: 10px;\n        /* padding: 16px; */\n    }\n\n    .form-outer-AI {\n        grid-template-columns: 1fr;\n        gap: 12px;\n        /* padding: 0 16px 16px; */\n    }\n\n    .execute-btn {\n        margin: 0 16px 16px;\n        width: calc(100% - 32px);\n    }\n\n    .params-grid {\n        gap: 12px;\n        padding: 16px;\n    }\n\n    .command-input-section {\n        padding: 16px;\n    }\n\n    .output-content {\n        padding: 16px;\n    }\n}\n\n@media (max-width: 480px) {\n    .command-header {\n        padding: 16px;\n    }\n\n    .header-title {\n        font-size: 20px;\n        margin-bottom: 8px;\n    }\n\n    .templates-grid {\n        grid-template-columns: repeat(2, 1fr);\n        gap: 8px;\n        /* padding: 12px; */\n    }\n\n    .template-btn {\n        padding: 10px;\n        gap: 6px;\n    }\n\n    .template-icon {\n        font-size: 18px;\n    }\n\n    .template-name {\n        font-size: 11px;\n    }\n\n    .command-input {\n        min-height: 80px;\n    }\n\n    /* .form-outer-AI {\n        padding: 0 12px 12px;\n    } */\n\n    .form-input-AI {\n        font-size: 12px;\n    }\n\n    .param-input {\n        font-size: 12px;\n    }\n\n    .execute-btn {\n        margin: 0 12px 12px;\n        width: calc(100% - 24px);\n        font-size: 13px;\n        padding: 12px 16px;\n    }\n}\n\n/* ==========================================\n   UTILITY CLASSES\n   =========================================== */\n\n.text-primary {\n    color: var(--text-primary);\n}\n\n.text-secondary {\n    color: var(--text-secondary);\n}\n\n.text-muted {\n    color: var(--text-muted);\n}\n\n.bg-light {\n    background: var(--bg-primary);\n}\n\n.border-light {\n    border-color: var(--border-color);\n}\n\n.shadow-md {\n    box-shadow: var(--shadow-md);\n}\n\n.transition {\n    transition: var(--transition);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
